import * as React from 'react';
import { useIntl } from 'react-intl';

import { Box, HStack } from '@fhs-legacy/universal-components';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';
import { routes } from 'utils/routing';

import {
  Points,
  PointsContainer,
  PointsLabel,
  StyledArrowLink,
  StyledPointsIcon,
  StyledRewardsLogo,
} from './rewards-link.styled';

interface IRewardsLinkProps {
  showPointsLabel?: boolean;
  textLabel?: string;
}

const RewardsLinkBase = ({ showPointsLabel, textLabel }: IRewardsLinkProps) => {
  const { formatMessage } = useIntl();
  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { loyaltyUser } = useLoyaltyUser();

  return loyaltyEnabled && loyaltyUser ? (
    <StyledArrowLink
      testID="loyalty-link"
      to={routes.rewards}
      labelEnd={
        <HStack>
          <StyledPointsIcon />
          <Points accessibilityLabel={`${loyaltyUser.points} ${formatMessage({ id: 'points' })}`}>
            {loyaltyUser.points}
          </Points>
        </HStack>
      }
    >
      <HStack>
        <Box _text={{ variant: 'copyOne' }} height="100%" testID="logo-box">
          {textLabel || <StyledRewardsLogo />}
        </Box>
        <PointsContainer>
          {showPointsLabel && <PointsLabel>{formatMessage({ id: 'points' })}</PointsLabel>}
        </PointsContainer>
      </HStack>
    </StyledArrowLink>
  ) : null;
};

export default RewardsLinkBase;
